// This file defines the predefined folder structure
// These folder names directly match the database enum values

export const PREDEFINED_FOLDERS = {
  documents: [
    "Design Briefs",
    "Design Documentation",
    "Reports",
    "Requirements",
    "Specifications",
    "Contracts",
    "Invoices",
  ],
  drawings: ["Plans", "Details", "Visuals"],
} as const;

// All predefined folder names - these exactly match the database enum
export const ALL_PREDEFINED_FOLDER_NAMES = [
  ...PREDEFINED_FOLDERS.documents,
  ...PREDEFINED_FOLDERS.drawings,
] as const;

// Map folder names to their default categories
export const FOLDER_CATEGORY_MAP: Record<string, "documents" | "drawings"> = {
  "Design Briefs": "documents",
  "Design Documentation": "documents",
  Reports: "documents",
  Requirements: "documents",
  Specifications: "documents",
  Contracts: "documents",
  Invoices: "documents",
  Plans: "drawings",
  Details: "drawings",
  Visuals: "drawings",
};
